import { useRoles } from '@/hooks/auth'
import { Navigate, Outlet } from 'react-router-dom'
import { Role } from '@/constants/role'

const AdmobLayout = () => {
  const isAdmober = useRoles([Role.Admober])
  if (!isAdmober) return <Navigate to="/403" />
  return <Outlet />
}

export default AdmobLayout
